import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import * as Icon from "react-feather";
import {sessionUser, useKeycloak} from "../config";
import {BASE_URL} from "../auth/authConfig";
import ProjectHeader from "./ProjectHeader";
import {getAppConfig} from "../services/utilService";
import CustomTooltip from "./common/CustomTooltip";
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';

function NavBar({handleToggle, OnUpdate, keycloakLogout}) {
    const [bugReportLink, setBugReportLink] = useState(null);

    useEffect(() => {
        // Get bug report link from app config. bugReportLink set to undefined if no configuration found.
        getAppConfig()
            .then(r => {
                let link = JSON.parse(r.data.response)
                    .find(a => a.Configuration_Name === "Bug Report Form Link")?.Configuration_Value;
                setBugReportLink(link);
            })
    }, []);

    return (
        <nav className="topnav navbar navbar-expand shadow navbar-light bg-white sticky-top">
            <Link className="navbar-brand" to="/">
                <img src={process.env.PUBLIC_URL + "/mquark_logo.png"}/>
            </Link>
            <button
                className="btn btn-transparent-dark order-2 order-lg-0 mr-lg-2"
                id="sidebarToggle"
                onClick={() => handleToggle()}
            >
                <Icon.Menu/>
            </button>
            <ProjectHeader OnUpdate={OnUpdate} selectedProject={''}/>
            <ul className="navbar-nav align-items-center ml-auto">

                {/* Report a Bug: only display if link exists */}
                {bugReportLink &&
                    <a className="nav-link" href={bugReportLink} target="_blank" rel="noreferrer">
                        <CustomTooltip title='Report a Bug' placement='bottom'>
                            <BugReportOutlinedIcon style={{color: 'rgba(31, 45, 65, 0.5)'}}/>
                        </CustomTooltip>
                    </a>
                }
                <li className="nav-item dropdown no-caret mr-2 dropdown-user">

                    <a
                        className="btn btn-transparent-dark dropdown-toggle"
                        id="userDropdown"
                        href="# "
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <Icon.User size={23}/>
                    </a>
                    <div
                        className="dropdown-menu dropdown-menu-left border-0 shadow animated--fade-in-up"
                        aria-labelledby="userDropdown"
                    >
                        <React.Fragment>
                            <h6 className="dropdown-header d-flex align-items-center">
                                <div className="dropdown-user-details">
                                    <div className="dropdown-user-details-name">
                                        {sessionStorage.getItem(sessionUser) != null && JSON.parse(sessionStorage.getItem(sessionUser))['Username']}
                                    </div>
                                    <div className="dropdown-user-details-email">
                                        {sessionStorage.getItem(sessionUser) != null && JSON.parse(sessionStorage.getItem(sessionUser))['Global_Role']}
                                    </div>
                                </div>
                            </h6>
                            <div className="dropdown-divider"></div>
                            {
                                !useKeycloak &&
                                <a href={BASE_URL + "Logout"} className="dropdown-item">
                                    <div className="dropdown-item-icon">
                                        <Icon.LogOut/>
                                    </div>
                                    Log Out
                                </a>
                            }
                            {
                                useKeycloak &&
                                <button className={'dropdown-item'} onClick={keycloakLogout}>
                                    <div className="dropdown-item-icon">
                                        <Icon.LogOut/>
                                    </div>
                                    Log Out
                                </button>
                            }
                        </React.Fragment>
                    </div>
                </li>
            </ul>
        </nav>
    );
}

export default NavBar;
